import classnames from 'classnames'
import { CurrentUserRoleType } from '~/graphqls/types'
import { getCurrentUserRole, UserRoleType } from '~/utils'

type VipType = {
  /** 用户角色 */
  userRole: UserRoleType | null | undefined
  /** 是否有描边 */
  border?: boolean
  style?: React.CSSProperties
  className?: string
}

/** tip:
 * 1. 兼容safari,样式需要都携带max-width,一般最大宽度时高度的1.5倍即可
 * 2. relative如果是a标签，需要变成blcok；
 *  */
export function VipIcon({
  userRole = {
    artist: false,
    aiArtist: false,
  },
  border = true,
  style,
  className,
}: VipType) {
  const role = getCurrentUserRole(userRole)
  return (
    <div
      className={classnames(
        className,
        border ? 'flex absolute bottom-0 right-0' : 'flex ml-1'
      )}
      style={style}
    >
      {role === CurrentUserRoleType.AI_ARTIST ? (
        border ? (
          <VipAiBorder />
        ) : (
          <VipAi />
        )
      ) : null}
      {role === CurrentUserRoleType.ARTIST ? (
        border ? (
          <VipNormalBorder />
        ) : (
          <VipNormal />
        )
      ) : null}
      {role === CurrentUserRoleType.ARTIST_AND_AIARTIST ? (
        border ? (
          <VipAiAndNoramlBorder />
        ) : (
          <VipAiAndNoraml />
        )
      ) : null}
    </div>
  )
}

/** 无边的普通创作者 */
export function VipNormal() {
  return (
    <svg
      className="w-full h-full"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05029 2.05029L7 0L4.94971 2.05029H2.05078V4.94922L0 7L2.05078 9.05078V11.9498H4.94979L7 14L9.05021 11.9498H11.9503V9.04972L14 7L11.9503 4.95028V2.05029H9.05029Z"
        fill="#7851EC"
      />
      <path
        d="M6.21635 9.91666H7.79327L9.625 4.66666H8.14904L7.0625 8.61489H6.97596L5.87981 4.66666H4.375L6.21635 9.91666Z"
        fill="#FCFCFD"
      />
    </svg>
  )
}
/** 无边的AI创作者 */
export function VipAi() {
  return (
    <svg
      className="w-full h-full"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05029 2.05029L7 0L4.94971 2.05029H2.05078V4.94922L0 7L2.05078 9.05078V11.9498H4.94979L7 14L9.05021 11.9498H11.9503V9.04972L14 7L11.9503 4.95028V2.05029H9.05029Z"
        fill="#23262F"
      />
      <path
        d="M4.85099 9.625H3.5L5.25476 4.375H6.92826L8.68302 9.625H7.33203L6.11056 5.69775H6.06993L4.85099 9.625ZM4.67069 7.55884H7.49456V8.52271H4.67069V7.55884Z"
        fill="#FFD166"
      />
      <path d="M10.5 4.375V9.625H9.24297V4.375H10.5Z" fill="#FFD166" />
    </svg>
  )
}

/** 无边的AI创作者及普通创作者 */
export function VipAiAndNoraml() {
  return (
    <svg
      className="w-full h-full"
      width="23"
      height="14"
      viewBox="0 0 23 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0503 2.05029L7 0L4.9497 2.05029H2.05077V4.94923L0 7L2.05077 9.05077V11.9498H4.94976L7 14L9.05018 11.9498H11.9503V9.04972L14 7L11.9503 4.95028V2.05029H9.0503Z"
        fill="#7851EC"
      />
      <path
        d="M6.21635 9.91667H7.79327L9.625 4.66667H8.14905L7.06247 8.6149H6.97597L5.87983 4.66667H4.375L6.21635 9.91667Z"
        fill="#FCFCFD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0503 2.05029L16 0L13.9497 2.05029H11.0508V4.94923L9 7L11.0508 9.05077V11.9498H13.9498L16 14L18.0502 11.9498H20.9503V9.04972L23 7L20.9503 4.95028V2.05029H18.0503Z"
        fill="#23262F"
      />
      <path
        d="M13.851 9.625H12.5L14.2548 4.375H15.9282L17.683 9.625H16.332L15.1105 5.69777H15.0699L13.851 9.625ZM13.6707 7.55883H16.4946V8.52273H13.6707V7.55883Z"
        fill="#FFD166"
      />
      <path d="M19.5002 4.375V9.625H18.2432V4.375H19.5002Z" fill="#FFD166" />
    </svg>
  )
}

/** 有边的普通创作者 */
export function VipNormalBorder() {
  return (
    <svg
      className="w-full h-full"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_10950_104794"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
        fill="black"
      >
        <rect fill="white" width="30" height="30" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51562V11.4844L3 15L6.51562 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        />
      </mask>
      <path
        d="M15 3L16.4142 1.58579L15 0.171573L13.5858 1.58579L15 3ZM18.5148 6.51479L17.1006 7.929L17.6864 8.51479H18.5148V6.51479ZM11.4852 6.51479V8.51479H12.3136L12.8994 7.929L11.4852 6.51479ZM6.51562 6.51479V4.51479H4.51562V6.51479H6.51562ZM6.51562 11.4844L7.92984 12.8986L8.51562 12.3128V11.4844H6.51562ZM3 15L1.58579 13.5858L0.171573 15L1.58579 16.4142L3 15ZM6.51562 18.5156H8.51562V17.6872L7.92984 17.1014L6.51562 18.5156ZM6.51562 23.4853H4.51562V25.4853H6.51562V23.4853ZM11.4853 23.4853L12.8996 22.0711L12.3138 21.4853H11.4853V23.4853ZM15 27L13.5858 28.4142L15 29.8284L16.4142 28.4142L15 27ZM18.5146 23.4853V21.4853H17.6862L17.1004 22.0711L18.5146 23.4853ZM23.4862 23.4853V25.4853H25.4862V23.4853H23.4862ZM23.4862 18.5138L22.072 17.0996L21.4862 17.6854V18.5138H23.4862ZM27 15L28.4142 16.4142L29.8284 15L28.4142 13.5858L27 15ZM23.4862 11.4862H21.4862V12.3146L22.072 12.9004L23.4862 11.4862ZM23.4862 6.51479H25.4862V4.51479H23.4862V6.51479ZM13.5858 4.41421L17.1006 7.929L19.929 5.10057L16.4142 1.58579L13.5858 4.41421ZM12.8994 7.929L16.4142 4.41421L13.5858 1.58579L10.071 5.10057L12.8994 7.929ZM6.51562 8.51479H11.4852V4.51479H6.51562V8.51479ZM8.51562 11.4844V6.51479H4.51562V11.4844H8.51562ZM4.41421 16.4142L7.92984 12.8986L5.10141 10.0702L1.58579 13.5858L4.41421 16.4142ZM7.92984 17.1014L4.41421 13.5858L1.58579 16.4142L5.10141 19.9298L7.92984 17.1014ZM8.51562 23.4853V18.5156H4.51562V23.4853H8.51562ZM11.4853 21.4853H6.51562V25.4853H11.4853V21.4853ZM16.4142 25.5858L12.8996 22.0711L10.0711 24.8996L13.5858 28.4142L16.4142 25.5858ZM17.1004 22.0711L13.5858 25.5858L16.4142 28.4142L19.9289 24.8996L17.1004 22.0711ZM23.4862 21.4853H18.5146V25.4853H23.4862V21.4853ZM21.4862 18.5138V23.4853H25.4862V18.5138H21.4862ZM25.5858 13.5858L22.072 17.0996L24.9004 19.928L28.4142 16.4142L25.5858 13.5858ZM22.072 12.9004L25.5858 16.4142L28.4142 13.5858L24.9004 10.072L22.072 12.9004ZM21.4862 6.51479V11.4862H25.4862V6.51479H21.4862ZM18.5148 8.51479H23.4862V4.51479H18.5148V8.51479Z"
        fill="white"
        mask="url(#path-1-outside-1_10950_104794)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51562V11.4844L3 15L6.51562 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        fill="#7851EC"
      />
      <path
        d="M13.6566 20H16.3599L19.5 11H16.9698L15.1071 17.7684H14.9588L13.0797 11H10.5L13.6566 20Z"
        fill="#FCFCFD"
      />
    </svg>
  )
}

/** 有边的AI创作者 */
export function VipAiBorder() {
  return (
    <svg
      className="w-full h-full "
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_10950_104802"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
        fill="black"
      >
        <rect fill="white" width="30" height="30" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51562V11.4844L3 15L6.51562 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        />
      </mask>
      <path
        d="M15 3L16.4142 1.58579L15 0.171573L13.5858 1.58579L15 3ZM18.5148 6.51479L17.1006 7.929L17.6864 8.51479H18.5148V6.51479ZM11.4852 6.51479V8.51479H12.3136L12.8994 7.929L11.4852 6.51479ZM6.51562 6.51479V4.51479H4.51562V6.51479H6.51562ZM6.51562 11.4844L7.92984 12.8986L8.51562 12.3128V11.4844H6.51562ZM3 15L1.58579 13.5858L0.171573 15L1.58579 16.4142L3 15ZM6.51562 18.5156H8.51562V17.6872L7.92984 17.1014L6.51562 18.5156ZM6.51562 23.4853H4.51562V25.4853H6.51562V23.4853ZM11.4853 23.4853L12.8996 22.0711L12.3138 21.4853H11.4853V23.4853ZM15 27L13.5858 28.4142L15 29.8284L16.4142 28.4142L15 27ZM18.5146 23.4853V21.4853H17.6862L17.1004 22.0711L18.5146 23.4853ZM23.4862 23.4853V25.4853H25.4862V23.4853H23.4862ZM23.4862 18.5138L22.072 17.0996L21.4862 17.6854V18.5138H23.4862ZM27 15L28.4142 16.4142L29.8284 15L28.4142 13.5858L27 15ZM23.4862 11.4862H21.4862V12.3146L22.072 12.9004L23.4862 11.4862ZM23.4862 6.51479H25.4862V4.51479H23.4862V6.51479ZM13.5858 4.41421L17.1006 7.929L19.929 5.10057L16.4142 1.58579L13.5858 4.41421ZM12.8994 7.929L16.4142 4.41421L13.5858 1.58579L10.071 5.10057L12.8994 7.929ZM6.51562 8.51479H11.4852V4.51479H6.51562V8.51479ZM8.51562 11.4844V6.51479H4.51562V11.4844H8.51562ZM4.41421 16.4142L7.92984 12.8986L5.10141 10.0702L1.58579 13.5858L4.41421 16.4142ZM7.92984 17.1014L4.41421 13.5858L1.58579 16.4142L5.10141 19.9298L7.92984 17.1014ZM8.51562 23.4853V18.5156H4.51562V23.4853H8.51562ZM11.4853 21.4853H6.51562V25.4853H11.4853V21.4853ZM16.4142 25.5858L12.8996 22.0711L10.0711 24.8996L13.5858 28.4142L16.4142 25.5858ZM17.1004 22.0711L13.5858 25.5858L16.4142 28.4142L19.9289 24.8996L17.1004 22.0711ZM23.4862 21.4853H18.5146V25.4853H23.4862V21.4853ZM21.4862 18.5138V23.4853H25.4862V18.5138H21.4862ZM25.5858 13.5858L22.072 17.0996L24.9004 19.928L28.4142 16.4142L25.5858 13.5858ZM22.072 12.9004L25.5858 16.4142L28.4142 13.5858L24.9004 10.072L22.072 12.9004ZM21.4862 6.51479V11.4862H25.4862V6.51479H21.4862ZM18.5148 8.51479H23.4862V4.51479H18.5148V8.51479Z"
        fill="white"
        mask="url(#path-1-outside-1_10950_104802)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51562V11.4844L3 15L6.51562 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        fill="#23262F"
      />
      <path
        d="M11.316 19.5H9L12.0082 10.5H14.877L17.8852 19.5H15.5692L13.4752 12.7676H13.4056L11.316 19.5ZM11.0069 15.958H15.8478V17.6104H11.0069V15.958Z"
        fill="#FFD166"
      />
      <path d="M21 10.5V19.5H18.8451V10.5H21Z" fill="#FFD166" />
    </svg>
  )
}

/** 有边的AI创作者及普通创作者 */
export function VipAiAndNoramlBorder() {
  return (
    <svg
      className="w-full h-full"
      width="44"
      height="30"
      viewBox="0 0 44 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_30040_170420"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <path d="M30 0H0V30H30V0Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5148 6.51479L15 3L11.4852 6.51479H6.5156V11.4844L3 15L6.5156 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
          fill="#141416"
        />
      </mask>
      <g mask="url(#mask0_30040_170420)">
        <path
          d="M15.0003 3L16.4145 1.58579L15.0003 0.17157L13.5861 1.58579L15.0003 3ZM18.5151 6.51479L17.1009 7.929L17.6867 8.51479H18.5151V6.51479ZM11.4855 6.51479V8.51479H12.3139L12.8997 7.929L11.4855 6.51479ZM6.51587 6.51479V4.51479H4.51587V6.51479H6.51587ZM6.51587 11.4844L7.93007 12.8986L8.51587 12.3128V11.4844H6.51587ZM3.00027 15L1.58607 13.5858L0.171875 15L1.58607 16.4142L3.00027 15ZM6.51587 18.5156H8.51587V17.6872L7.93007 17.1014L6.51587 18.5156ZM6.51587 23.4853H4.51587V25.4853H6.51587V23.4853ZM11.4856 23.4853L12.8999 22.0711L12.3141 21.4853H11.4856V23.4853ZM15.0003 27L13.5861 28.4142L15.0003 29.8284L16.4145 28.4142L15.0003 27ZM18.5149 23.4853V21.4853H17.6865L17.1007 22.0711L18.5149 23.4853ZM23.4865 23.4853V25.4853H25.4865V23.4853H23.4865ZM23.4865 18.5138L22.0723 17.0996L21.4865 17.6854V18.5138H23.4865ZM27.0003 15L28.4145 16.4142L29.8287 15L28.4145 13.5858L27.0003 15ZM23.4865 11.4862H21.4865V12.3146L22.0723 12.9004L23.4865 11.4862ZM23.4865 6.51479H25.4865V4.51479H23.4865V6.51479ZM13.5861 4.41421L17.1009 7.929L19.9293 5.10057L16.4145 1.58579L13.5861 4.41421ZM12.8997 7.929L16.4145 4.41421L13.5861 1.58579L10.0713 5.10057L12.8997 7.929ZM6.51587 8.51479H11.4855V4.51479H6.51587V8.51479ZM8.51587 11.4844V6.51479H4.51587V11.4844H8.51587ZM4.41447 16.4142L7.93007 12.8986L5.10168 10.0702L1.58607 13.5858L4.41447 16.4142ZM7.93007 17.1014L4.41447 13.5858L1.58607 16.4142L5.10168 19.9298L7.93007 17.1014ZM8.51587 23.4853V18.5156H4.51587V23.4853H8.51587ZM11.4856 21.4853H6.51587V25.4853H11.4856V21.4853ZM16.4145 25.5858L12.8999 22.0711L10.0714 24.8996L13.5861 28.4142L16.4145 25.5858ZM17.1007 22.0711L13.5861 25.5858L16.4145 28.4142L19.9292 24.8996L17.1007 22.0711ZM23.4865 21.4853H18.5149V25.4853H23.4865V21.4853ZM21.4865 18.5138V23.4853H25.4865V18.5138H21.4865ZM25.5861 13.5858L22.0723 17.0996L24.9007 19.928L28.4145 16.4142L25.5861 13.5858ZM22.0723 12.9004L25.5861 16.4142L28.4145 13.5858L24.9007 10.072L22.0723 12.9004ZM21.4865 6.51479V11.4862H25.4865V6.51479H21.4865ZM18.5151 8.51479H23.4865V4.51479H18.5151V8.51479Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5148 6.51479L15 3L11.4852 6.51479H6.5156V11.4844L3 15L6.5156 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        fill="#7851EC"
      />
      <path
        d="M13.6566 20H16.3599L19.5 11H16.9698L15.1071 17.7684H14.9588L13.0797 11H10.5L13.6566 20Z"
        fill="#FCFCFD"
      />
      <mask
        id="mask1_30040_170420"
        maskUnits="userSpaceOnUse"
        x="18"
        y="0"
        width="30"
        height="30"
      >
        <path d="M48 0H18V30H48V0Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.5148 6.51479L33 3L29.4852 6.51479H24.5156V11.4844L21 15L24.5156 18.5156V23.4854H29.4854L33 27L36.5146 23.4854H41.4862V18.5138L45 15L41.4862 11.4862V6.51479H36.5148Z"
          fill="#141416"
        />
      </mask>
      <g mask="url(#mask1_30040_170420)">
        <path
          d="M33.0003 3L34.4145 1.58579L33.0003 0.17157L31.5861 1.58579L33.0003 3ZM36.5151 6.51479L35.1009 7.929L35.6867 8.51479H36.5151V6.51479ZM29.4855 6.51479V8.51479H30.3139L30.8997 7.929L29.4855 6.51479ZM24.5159 6.51479V4.51479H22.5159V6.51479H24.5159ZM24.5159 11.4844L25.9301 12.8986L26.5159 12.3128V11.4844H24.5159ZM21.0003 15L19.5861 13.5858L18.1719 15L19.5861 16.4142L21.0003 15ZM24.5159 18.5156H26.5159V17.6872L25.9301 17.1014L24.5159 18.5156ZM24.5159 23.4854H22.5159V25.4854H24.5159V23.4854ZM29.4857 23.4854L30.8999 22.0711L30.3141 21.4854H29.4857V23.4854ZM33.0003 27L31.5861 28.4142L33.0003 29.8284L34.4145 28.4142L33.0003 27ZM36.5149 23.4854V21.4854H35.6865L35.1007 22.0711L36.5149 23.4854ZM41.4865 23.4854V25.4854H43.4865V23.4854H41.4865ZM41.4865 18.5138L40.0723 17.0996L39.4865 17.6854V18.5138H41.4865ZM45.0003 15L46.4145 16.4142L47.8287 15L46.4145 13.5858L45.0003 15ZM41.4865 11.4862H39.4865V12.3146L40.0723 12.9004L41.4865 11.4862ZM41.4865 6.51479H43.4865V4.51479H41.4865V6.51479ZM31.5861 4.41421L35.1009 7.929L37.9293 5.10057L34.4145 1.58579L31.5861 4.41421ZM30.8997 7.929L34.4145 4.41421L31.5861 1.58579L28.0713 5.10057L30.8997 7.929ZM24.5159 8.51479H29.4855V4.51479H24.5159V8.51479ZM26.5159 11.4844V6.51479H22.5159V11.4844H26.5159ZM22.4145 16.4142L25.9301 12.8986L23.1017 10.0702L19.5861 13.5858L22.4145 16.4142ZM25.9301 17.1014L22.4145 13.5858L19.5861 16.4142L23.1017 19.9298L25.9301 17.1014ZM26.5159 23.4854V18.5156H22.5159V23.4854H26.5159ZM29.4857 21.4854H24.5159V25.4854H29.4857V21.4854ZM34.4145 25.5858L30.8999 22.0711L28.0714 24.8996L31.5861 28.4142L34.4145 25.5858ZM35.1007 22.0711L31.5861 25.5858L34.4145 28.4142L37.9292 24.8996L35.1007 22.0711ZM41.4865 21.4854H36.5149V25.4854H41.4865V21.4854ZM39.4865 18.5138V23.4854H43.4865V18.5138H39.4865ZM43.5861 13.5858L40.0723 17.0996L42.9007 19.928L46.4145 16.4142L43.5861 13.5858ZM40.0723 12.9004L43.5861 16.4142L46.4145 13.5858L42.9007 10.072L40.0723 12.9004ZM39.4865 6.51479V11.4862H43.4865V6.51479H39.4865ZM36.5151 8.51479H41.4865V4.51479H36.5151V8.51479Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5148 6.51479L33 3L29.4852 6.51479H24.5156V11.4844L21 15L24.5156 18.5156V23.4854H29.4854L33 27L36.5146 23.4854H41.4862V18.5138L45 15L41.4862 11.4862V6.51479H36.5148Z"
        fill="#23262F"
      />
      <path
        d="M29.316 19.5H27L30.0082 10.5H32.877L35.8852 19.5H33.5692L31.4752 12.7676H31.4056L29.316 19.5ZM29.0069 15.958H33.8478V17.6104H29.0069V15.958Z"
        fill="#FFD166"
      />
      <path d="M38.9996 10.5V19.5H36.8447V10.5H38.9996Z" fill="#FFD166" />
    </svg>
  )
}
